import {Answer} from 'Models'
import { calcSimplePoints } from '../_common/pointsCalculationHelper';

const log = x => { console.log(x); return x }

export const calculatePoints = answer => {
    return answer.question().doesOrderCount() ?
           calcPointsWhenOrderDoesCount(answer) :
           calcPointsWhenOrderDoesNotCount(answer)
}

const calcPointsWhenOrderDoesCount = answer => {
    const userInput         = answer.userInput()
    const question          = answer.question()
    const isCountPerAnswer  = question.countPerAnswer()
    const points            = () => Number(question.points())

    if(userInput.length<1) return 0

    const optionsOf         = x => x.value.expected.toString().trim().split(';')
    const answeredStateOf   = x => optionsOf(x).some( y => y.trim() === x.value.given)
    const mapToAnswerStates = ui => ui.map(answeredStateOf)
    const countCorrectOnes  = () => mapToAnswerStates(userInput).filter( x => x===true ).length

    return isCountPerAnswer ? countCorrectOnes()*points() : calcSimplePoints(answer)
}

const calcPointsWhenOrderDoesNotCount = answer => {
    const userInput             = answer.userInput()
    const correctAnswers        = answer.question().correctAnswers()
    const doesCountPerAnswer    = answer.countPerAnswer()
    const points                = () => Number(answer.question().points())

    if(userInput.length<1)
        return 0

    const answersAreEqual   = (ca,ui) => ca.toString().trim() === ui.value.given.toString().trim()
    const correctCount      = userInput.map( ui => {
                return correctAnswers.filter( ca => answersAreEqual(ca,ui) ).length > 0
            })
            .filter( x => x===true )
            .length

    return doesCountPerAnswer  ? correctCount*points() : calcSimplePoints(answer)
}
